import React from 'react'

const Icon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'>
      <path
        d='M3.18255 17.5833L2.4165 16.8173L8.15046 11.0833H4.4165V9.99996H9.99984V15.5833H8.9165V11.8493L3.18255 17.5833ZM9.99984 9.99996V4.41663H11.0832V8.15058L16.8171 2.41663L17.5832 3.18267L11.8492 8.91663H15.5832V9.99996H9.99984Z'
        fill='#686867'
      />
    </svg>
  )
}

export default Icon
